import React from "react";
import { CtaButton } from "./CtaButton";
type SectionCtaProps = {
  label: string;
  note?: string;
  tone?: "dark" | "light";
};
export function SectionCta({
  label,
  note = "Instant digital access · One-time payment of $27 USD",
  tone = "light"
}: SectionCtaProps) {
  return <div className="mt-12 flex flex-col items-center gap-4 sm:mt-14" data-id="element-59" data-mp="3nc9rxynuhq4m">
      <CtaButton label={label} data-id="element-60" data-mp="3nemkf5r8bivx" />
      <p className={`text-center text-sm font-medium ${tone === "dark" ? "text-white/70" : "text-muted"}`} data-id="element-61" data-mp="38nvr1t9zobqp">{note}</p>
    </div>;
}